<template>
  <SogCard>
    <SogCardContent>
      <table>
        <tr>
          <td colspan="2">
            <SogDataLabel :value="item.productType" />
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <SogDataLabel :value="item.product" />
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <SogDataLabel :value="item.manufacturer" />
          </td>
        </tr>
        <tr>
          <td>Anzahl</td>
          <td>
            <SogDataLabel
              :value="item.count"
            />
          </td>
        </tr>
        <tr v-show="_exportCardInsuranceNumber">
          <td colspan="2">
            <SogDataLabel :value="_exportCardInsuranceNumber" />
          </td>
        </tr>
        <tr v-show="_exportCardNumber">
          <td colspan="2">
            <SogDataLabel :value="_exportCardNumber" />
          </td>
        </tr>
        <tr v-show="item.grossPrice>0">
          <td>Bruttoprämie</td>
          <td>
            <SogDataLabel
              :value="item.grossPrice"
              :value-type="SogDataLabelValueType.Money"
            />
          </td>
        </tr>
        <tr v-show="isInvoiced && item.amount>0">
          <td>Zahlungsbetrag</td>
          <td>
            <SogDataLabel
              :value="item.amount"
              :value-type="SogDataLabelValueType.Money"
            />
          </td>
        </tr>
      </table>
    </SogCardContent>
    <slot />
  </SogCard>
</template>

<script setup lang="ts">

import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import {computed} from "vue";
import ShoppingCartItem from "@/shared/model/shoppingCartItem";
import {sortInsuranceExportBlank} from "@/shared/model/InsuranceExportBlank";

interface Props {
  item: {
    id: string,
    productType: string,
    product: string,
    count: number,
    grossPrice: number,
    amount: number,
    manufacturer: string,
    item: ShoppingCartItem | undefined
  }
  isInvoiced: boolean
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
    isInvoiced: false
  }
)


const _exportCardNumber = computed(() => {
  if (props.item.item) {
    if (props.item.item.insuranceExportBlanks.length > 0) {
      return sortInsuranceExportBlank(props.item.item.insuranceExportBlanks).map(t => t.blankNumber).join(", ")
    }
  }
  return undefined
})

const _exportCardInsuranceNumber = computed(() => {
  if (props.item.item) {
    if (props.item.item.insuranceExportBlanks.length > 0) {
      return sortInsuranceExportBlank(props.item.item.insuranceExportBlanks).map(t => t.insuranceNumber).join(", ")
    }
  }
  return undefined
})

</script>

<style scoped>

</style>
